<!--hot commodity-->
<template>
  <div class="panel promotionItem">
    <div class="title">Hot Product Settings</div>
    <div class="serch_box">
      <el-form :inline="true" class="user-search fixed_form">
        <el-form-item label="Enterprise Name:" size="mini">
          <template>
            <el-select v-model="enterpriseNameCode" popper-class="enterpriseNameClass" filterable placeholder="Please enter company name" @change="changeEnterpriseFn">
              <el-option
                v-for="item in EnterpriseList"
                :key="item.id"
                :label="item.label"
                :value="item.value"
              />
            </el-select>
          </template>
        </el-form-item>
        <el-form-item label="Contract No:" size="">
          <template>
            <el-input v-model.trim="form.contractNo" placeholder="Pleas Enter">
              <el-button
                slot="append"
                style="width:30px;height:32px;line-height: 32px;text-align:center;"
                @click="showSku"
              >
                <i class="el-icon-search" style="margin-top:16px" />
              </el-button>
            </el-input>
          </template>
        </el-form-item>
        <el-button type="" @click="offBtn">Reset</el-button>
        <el-button type="primary" icon="el-icon-search" @click="searchBtn">
          Search
        </el-button>
      </el-form>
      <el-button
        type="primary"
        icon="el-icon-plus"
        style="margin-top: 32px"
        @click="addBtn"
      >
        Add
      </el-button>
      <el-button v-if="false" style="margin-top: 32px" @click="BatchDelete">
        Batch delete
      </el-button>
    </div>
    <div class="panel-body">
      <el-table
        ref="multipleTable"
        :data="tableList"
        fit
        style="width: 100%"
        :header-cell-style="{ background: '#e8f1fe' }"
        @selection-change="handleSelectionChange"
      >
        <!-- 修改无数据时 提示文字 -->
        <template slot="empty" class="logo_no">
          <!-- <img :src="emptyImgSrc" alt="" width="118px" height="110px"> -->
          <p style="color: #969799;">No more data</p>
        </template>
        <el-table-column type="selection" width="55" />
        <el-table-column
          label="Contract No"
          width="200"
          :show-overflow-tooltip="true"
        >
          <template slot-scope="scope">
            <span>
              {{ scope.row.contractNo || '--' }}
            </span>
          </template>
        </el-table-column>
        <el-table-column
          label="SKU Number"
          width="200"
          :show-overflow-tooltip="true"
        >
          <template slot-scope="scope">
            <span>{{ scope.row.count || '--' }}</span>
          </template>
        </el-table-column>
        <el-table-column label="SKU Image">
          <template slot-scope="scope">
            <div style="display:flex; overflow: hidden;">
              <img
                v-for="(item, index) in scope.row.imgUrls"
                :key="index"
                :src="item.indexOf('http') == -1 ? imgHeaderInit + item : item"
                alt=""
                width="128px"
                style="cursor:pointer; margin-left:16px"
                @click="handlePreview(item)"
              >
            </div>
          </template>
        </el-table-column>
        <el-table-column label="Operate" width="200" fixed="right" align="left">
          <template slot-scope="scope">
            <div class="btn_box">
              <el-button
                
                type="text"
                size="small"
                @click="handleUpdate(scope.row)"
              >
                Manage
              </el-button>
              <el-button
                
                type="text"
                size="small"
                @click="handleDel(scope.row)"
              >
                Delete
              </el-button>
            </div>
          </template>
        </el-table-column>
      </el-table>
      <div class="pageWrapper">
        <el-pagination
          :current-page="listQuery.pageCode"
          :page-sizes="[10, 20, 50, 100]"
          :page-size="listQuery.pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="listQuery.total"
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
        />
      </div>
    </div>
    <el-dialog
      :title="textMap[dialogStatus]"
      :visible.sync="dialogFormVisible"
      width="687px"
    >
      <el-form
        ref="postForm"
        :model="postForm"
        :rules="rules"
        label-width="150px"
        @closed="dialogFormVisibleFn"
      >
        <el-form-item v-if="dialogStatus == 'create'" label="Enterprise Name">
          <template>
            <el-select v-model="enterpriseNameCodeAdd" popper-class="enterpriseNameClass" filterable placeholder="Please enter company name" @change="changeEnterpriseAddFn">
              <el-option
                v-for="item in EnterpriseList"
                :key="item.id"
                :label="item.label"
                :value="item.value"
              />
            </el-select>
          </template>
        </el-form-item>
        <el-form-item label="Contract No">
          <el-input
            v-model.trim="postForm.contractNo"
            placeholder="Please enter the Contract No"
          />
        </el-form-item>
        <el-form-item label="SKU ID" prop="skuId">
          <el-input
            v-model.trim="postForm.skuId"
            type="textarea"
            :rows="5"
            oninput="value=value.replace(/[^\d\,]/g,'')"
            placeholder="Please enter the SKU ID"
          />
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogFormVisibleFn">Cancel</el-button>
        <el-button
          type="primary"
          @click="createData('postForm')"
        >
          Confirm
        </el-button>
      </div>
    </el-dialog>
    <!-- 缩略图 -->
    <el-dialog :visible.sync="dialogVisible" width="1000px">
      <img
        style="display: block; margin: 0 auto 40px; max-width: 100%"
        :src="dialogImageUrl"
        alt=""
      >
    </el-dialog>
    <el-dialog title="Choice Contract No" :visible.sync="dialogSKU" width="50%">
      <Delotal @handleCurrentChanges="handleCurrentChanges" />
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogSKU = false">Cancel</el-button>
        <el-button
          
          type="primary"
          @click="updateDatas('postForm')"
        >
          Confirm
        </el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
// 引入API接口
import {
  getSKUList,
  dleteSKU,
  addHotShopping,
  BatchDelete
} from '@/api/user/list';
import { checkLongThree } from '@/api/user/rules.js';
import Delotal from '../contractManage/conttemplat.vue';
import {image_base_url} from '@/common/config/index.js'
import { getEnterpriseName } from '@/api/enterprise/enterprise';
const defaultForm = {
  skuId: '',
  skuIds: [],
  contractNo: ''
};
export default {
  inject: ['reload'],
  components: {
    Delotal
  },
  data() {
    return {
      emptyImgSrc: '',
      imgHeaderInit: image_base_url,
      postForm: Object.assign({}, defaultForm),
      // 配置分页信息
      listQuery: {
        pageSize: 10,
        pageCode: 1,
        total: 0
      },
      // 配置弹窗信息
      textMap: {
        update: 'Update Hot Product',
        create: 'Add Hot Product'
      },
      dialogFormVisible: false,
      dialogVisible: false,
      dialogImageUrl: '',
      dialogStatus: 'update',
      // 搜索条件
      form: {
        contractNo: ''
      },
      // 后端获取表格信息
      tableList: [],
      // 选中列表信息项
      multipleSelection: [],
      // 非空验证
      rules: {
        skuId: [
          {
            required: true,
            message: 'Please enter the Squence number',
            trigger: 'blur'
          },
          { validator: checkLongThree, length: 301, trigger: 'blur' }
        ],
        // contractNo: [
        //   {
        //     required: true,
        //     message: 'Please enter contractNo',
        //     trigger: 'blur'
        //   }
        // ]
      },
      loading: true,
      dialogSKU: false,
      multipleSelections: '',
      EnterpriseList: [],
      enterpriseNameCode: '',
      enterpriseNameCodeAdd: ''
    };
  },
  watch: {
    dialogFormVisible() {
      this.$nextTick(()=>{
        this.$refs['postForm'].resetFields();
      })
    }
  },
  created() {
    // 初始化表数据
    this.getFirstData();
    this.getEnterpriseNameData();
    this.emptyImgSrc = '';
  },
  methods: {
    // 添加页面 切换企业名称，回显合同号
    changeEnterpriseAddFn(val) {
      if (this.dialogStatus == 'create') {
        this.postForm.contractNo = val;
      }
    },
    // 弹窗取消
    dialogFormVisibleFn() {
      this.dialogFormVisible = false;
      this.enterpriseNameCodeAdd = '';
    },
    // 切换企业名称，回显合同号
    changeEnterpriseFn(val) {
      this.form.contractNo = val;
    },
    // 根据企业名称查询 合同号
    getEnterpriseNameData() {
      getEnterpriseName().then(res => {
        if (res.code === 200) {
          var list = [];
          if (res.data && res.data.length > 0) {
            for (let i = 0; i < res.data.length; i++) {
              const element = res.data[i];
              if (element.contractNo != null) {
                list.push({
                  value: element.contractNo,
                  label: element.enterpriseName,
                  id: element.id
                });
              }
            }
            this.EnterpriseList = list;
          } else {
            this.EnterpriseList = [];
          }
        }
      });
    },
    showSku() {
      this.dialogSKU = true;
    },
    handleCurrentChanges(val) {
      console.log(val);
      this.multipleSelections = val;
    },
    updateDatas() {
      console.log(this.multipleSelections);

      this.form.contractNo = this.multipleSelections.contractNo;
      this.dialogSKU = false;
    },
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    // 获取页面数据
    getFirstData() {
      getSKUList(
        Object.assign(
          {
            pageNo: this.listQuery.pageCode,
            pageSize: this.listQuery.pageSize
          },
          this.form
        )
      ).then(res => {
        if (res.success && res.code === 200) {
          this.tableList = res.data.dataList;
          this.listQuery.total = res.data.totalCount;
        } else {
          // 暂无数据
          this.tableList = [];
          this.listQuery.total = 0;
          this.$message({
            message: res.msg,
            type: 'error'
          });
        }
      });
    },
    // 新增
    addBtn() {
      this.postForm = Object.assign({}, defaultForm);
      this.dialogStatus = 'create';
      this.dialogFormVisible = true;
    },
    // 分页信息-设置条数
    handleSizeChange(val) {
      this.listQuery.pageSize = val;
      this.getFirstData();
    },
    // 分页信息-切换页数
    handleCurrentChange(val) {
      this.listQuery.pageCode = val;
      this.getFirstData();
    },
    // 搜索栏-搜索按钮
    searchBtn() {
      //console.log(this.form);
      this.listQuery.pageCode = 1;
      this.getFirstData();
    },
    // 搜索栏-清空按钮
    offBtn() {
      this.reload();
      this.enterpriseNameCode = '';
    },
    // 列表-修改按钮
    handleUpdate(row) {
      this.$router.push({
        name: 'product promotion particulars',
        query: { contractNo: row.contractNo }
      });
    },
    // 列表-删除按钮
    handleDel(row) {
      this.$confirm('Delete all hot goods under this contract number?', 'warning', {
        confirmButtonText: 'confirm',
        cancelButtonText: 'cancel',
        type: 'warning'
      })
        .then(() => {
          dleteSKU(row.contractNo).then(res => {
            if (res.code == 200) {
              this.$message({
                message: 'successfully delete',
                type: 'success'
              });
              this.getFirstData();
              this.dialogFormVisible = false;
            } else {
              this.$message({
                message: res.msg,
                type: 'error'
              });
              
            }
          });
        })
        .catch(function() {});
    },
    // 弹窗-新增确定
    createData() {
      let than = this;
      this.$refs['postForm'].validate(valid => {
        if (valid) {
          than.postForm.skuIds = than.postForm.skuId.split(',');
          let obj = {
            skuIds: than.postForm.skuIds,
            contractNo: than.postForm.contractNo
          }
          addHotShopping(obj).then(res => {
            if (res.code == 200) {
              this.$message({
                message: 'successfully upload',
                type: 'success'
              });
              this.getFirstData();
              this.dialogFormVisible = false;
            } else {
              this.$message({
                message: res.msg,
                type: 'error'
              });
              
            }
          });
        } else {
          //console.log('error submit!!');
          return false;
        }
      });
    },
    handlePreview(file) {
      this.dialogImageUrl = file;
      this.dialogVisible = true;
    },
    BatchDelete() {
      if (this.multipleSelection.length > 0) {
        var list = [];
        for (let i = 0; i < this.multipleSelection.length; i++) {
          const element = this.multipleSelection[i];
          list.push(element.id);
        }
        BatchDelete(list).then(res => {
          if (res.code == 200) {
            this.$message({
              message: 'Delete succeeded',
              type: 'success'
            });
            this.getFirstData();
          }
        });
      } else {
        this.$message({
          message: 'Please select the content to delete',
          type: 'error'
        });
      }
    }
  }
};
</script>
<style lang="less" scoped>
.promotionItem {
  ::v-deep .el-form-item__content {
    display: flex;
    align-items: center;
  }
  .el-input {
    width: 200px;
    margin-right: 40px;
  }
  ::v-deep .el-input__inner {
    height: 32px;
    line-height: 30px;
  }
  .el-pagination__editor.el-input {
    width: 50px;
  }
  .pageWrapper {
    margin: 10px 10px 10px 0;
    float: right;
    height: 45px;
  }
}
.title {
  height: 66px;
  border-bottom: 1px solid rgba(183, 188, 201, 0.3);
  padding: 24px 16px;
  font-size: 16px;
  font-weight: Bold;
  line-height: 17px;
}
.logo_no {
  display: flex;
  flex-direction: column;
  justify-content: center;
}
.serch_box {
  width: 100%;
  background: #fff;
  padding: 24px 16px 18px;
}
.avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}
.avatar-uploader .el-upload:hover {
  border-color: #2262ff;
}
.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 178px;
  height: 178px;
  line-height: 178px;
  text-align: center;
}
.avatar {
  width: 178px;
  height: 178px;
  display: block;
}
.fixed_form {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  div {
    display: flex;
    //flex-direction: column;
    margin-bottom: 0;
    /deep/.el-form-item__label {
      text-align: left;
    }
  }
}
.panel-body {
  padding: 0 16px;
}
/deep/.el-button {
  // padding: 0 12px !important;
  width: 100px;
  font-family: ArialMT;
  font-size: 14px;
}

::v-deep .el-table {
  .cell {
    white-space: pre-wrap;
    word-break: keep-all;
  }
}

::v-deep .el-pager {
  li {
    border: 0;
  }
}
::v-deep .el-button--primary {
  color: #fff;
  background-color: #2262ff;
  border-color: #2262ff;
}
::v-deep .el-button--text {
  color: #2262ff;
}

::v-deep .el-dialog__body {
  padding: 8px 16px 16px;

  // .el-input {
  //   width: 330px;
  // }
}
.btn_box {
  display: flex;
  flex-direction: column;
  button:nth-of-type(2) {
    margin: 0 !important;
  }
  button{
    text-align: left;
  }
}
</style>
